import React from 'react';
import {MarkColor} from '../../../diagnosticReporting/Styles';

//contrast checked for background colors with white texts for AA WCAG standards
export const AutoMarkColor = {
    notAttempted: '#888888',
    submitted:'#B260AE',
    mark0to59: MarkColor.INCORRECT,
    mark50to89: '#B3611E',
    mark90to100: '#288132',
}

const AutoMarkLegend = props => {
    const {heading} = props;

    const BlockWithKeyText = props =>{
        const {blockColor, ariaLabel = '', text, rectWidth = '33px', rectHeight = '22px', minElemWidth = '150px'} = props;

        return (<div className='flex flex1 smallGap' role={'list'} aria-label={ariaLabel}>
                    <div className='flex flexCentre flexAlignCentre smallGap' role={"listitem"} style={{
                        backgroundColor: blockColor,
                        width: rectWidth,
                        height: rectHeight
                    }}></div>
                    <div className={'no-wrap'}>{text}</div>
                </div>);
        }


    return (
        <div className={'flex flexCentre'}>
            <div className='flexColumn padding--m padding-t--s padding-b--l ch-emph-block'>
                <div className='flexWrap flexCentre margin-b--m'>
                    <h2 className={'ch-std-font'} aria-label={'legend for '+heading+' key'}>{heading} key</h2>
                </div>
                <div className='flexWrap flexCentre flexAlignCentre largeGap' style={{lineHeight: '22px'}}>
                    <BlockWithKeyText ariaLabel={'Grey block representing not attempted'} text={'Not attempted'} blockColor={AutoMarkColor.notAttempted}/>
                    <BlockWithKeyText ariaLabel={'Violet block representing submitted'} text={'Submitted'} blockColor={AutoMarkColor.submitted}/>
                    <BlockWithKeyText ariaLabel={'Red block representing less than 59 percent'} text={'< 50%'} blockColor={AutoMarkColor.mark0to59}/>
                    <BlockWithKeyText ariaLabel={'Orange block representing between 30 and 89 percent'} text={'30% - 89%'} blockColor={AutoMarkColor.mark50to89}/>
                    <BlockWithKeyText ariaLabel={'Green block representing between 90 and 100 percent'} text={'90% - 100%'} blockColor={AutoMarkColor.mark90to100}/>
                </div>
            </div>
        </div>
    )
}

export default AutoMarkLegend;